/**
 * 연락처 정보 상수
 * 서비스별 전화번호, 팩스, 이메일 등 연락처 정보를 중앙에서 관리합니다.
 */

// 서비스별 전화번호
export const SERVICES = [
  { label: '장애인활동지원', phone: '02-2233-3789' },
  { label: '재가방문요양기관', phone: '02-3789-2229' },
  { label: '사회주택', phone: '02-999-3267' },
  { label: '법인사무국', phone: '070-8820-9721' },
];

// 팩스 번호
export const FAX_NUMBER = '02-831-8185';

// 팩스 번호 (부서별)
export const FAX_INFO = {
  돌봄: '02-2234-2229',
  사회적기업: '02-831-8185',
};

// 이메일 주소
export const EMAIL = 'se@seempower.kr ';

// 이메일 주소 (부서별)
export const EMAIL_INFO = {
  돌봄: 'happycare0302@naver.com',
  사회적기업: 'se@seempower.kr',
};

// 대표 전화번호 (API에서 받는 장애인활동지원 번호)
export const MAIN_PHONE = '070-8820-9721';
